import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, UserRound } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { Logo } from "./Logo";
import { ESPACE_CLIENT_URL } from "@/data/site";

export const NAV = [
  { to: "/", label: "Accueil", id: "accueil" },
  { to: "/prestations", label: "Services", id: "prestations" },
  { to: "/conciergerie-militaires-brest/", label: "Militaires", id: "militaires" },
  { to: "/tarifs-conciergerie-brest/", label: "Tarifs", id: "tarifs" },
  { to: "/a-propos", label: "À propos", id: "a-propos" },
  { to: "/contact", label: "Contact", id: "contact" },
];

const linkCls = ({ isActive }) =>
  `relative text-sm font-semibold transition-colors duration-200 hover:text-[#D82C2C] ${isActive ? "text-[#D82C2C]" : "text-[#0F2840]"}`;

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-[#0F2840]/10 bg-white/80 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 lg:px-8">
        <Link to="/" data-testid="header-home-link"><Logo /></Link>
        <nav className="hidden items-center gap-7 lg:flex">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end className={linkCls} data-testid={`nav-${n.id}`}>{n.label}</NavLink>
          ))}
        </nav>
        <div className="hidden items-center gap-3 lg:flex">
          <a href={ESPACE_CLIENT_URL} data-testid="header-espace-client-btn"
            className="inline-flex items-center gap-2 rounded-full border border-[#0F2840]/20 px-4 py-2 text-sm font-semibold text-[#0F2840] transition-colors hover:border-[#0F2840] hover:bg-[#0F2840] hover:text-white">
            <UserRound className="h-4 w-4" /> Espace client
          </a>
          <Link to="/devis" data-testid="header-devis-btn"
            className="rounded-full bg-[#D82C2C] px-5 py-2 text-sm font-bold text-white transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#b82323]">
            Demander un devis
          </Link>
        </div>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button className="grid h-11 w-11 place-items-center rounded-full border border-[#0F2840]/15 lg:hidden" data-testid="mobile-menu-btn" aria-label="Menu">
              <Menu className="h-5 w-5" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[300px] bg-[#0F2840] text-white [&>button]:text-white [&>button]:opacity-90" data-testid="mobile-menu">
            <SheetTitle className="sr-only">Menu</SheetTitle>
            <div className="mt-6"><Logo light /></div>
            <nav className="mt-10 flex flex-col gap-1">
              {[...NAV, { to: "/devis", label: "Demander un devis", id: "devis" }].map((n) => (
                <Link key={n.to} to={n.to} onClick={() => setOpen(false)} data-testid={`mobile-nav-${n.id}`}
                  className="border-b border-white/10 py-3.5 font-display text-xl transition-colors hover:text-[#ff6b6b]">
                  {n.label}
                </Link>
              ))}
              <a href={ESPACE_CLIENT_URL} data-testid="mobile-nav-connexion"
                className="border-b border-white/10 py-3.5 font-display text-xl transition-colors hover:text-[#ff6b6b]">
                Espace client
              </a>
            </nav>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};
